module.exports = __webpack_public_path__ + "img/loading.172741b2.gif";